// @flow
import * as React from 'react';
import Head from 'next/head';
import { FormattedMessage } from 'react-intl';
import GlobalCss from '../../../../common/GlobalCss';
import HeaderHome from '../../../../common/Header/HeaderHome';
import SourcesList from '../../../list/components/SourcesList/container';
import messages from './messages';
import styles from './styles';

type Props = {
  verticalName: string,
};

export default function LayoutRedirectingTo({ verticalName }: Props): React.Node {
  return (
    <div className="redirection-loading">
      <Head>
        <GlobalCss />
      </Head>
      <HeaderHome
        verticalName={verticalName}
        title={<FormattedMessage {...messages.title} />}
        subtitle={<FormattedMessage {...messages.subtitle} />}
      />

      <div className="loading-wrapper">
        <svg width="60" height="60" viewBox="0 0 108 108">
          <path
            d="M54 102C80.5 102 102 80.5 102 54 102 27.5 80.5 6 54 6 27.5 6 6 27.5 6 54 6 80.5 27.5 102 54 102ZM54 108C24.2 108 0 83.8 0 54 0 24.2 24.2 0 54 0 83.8 0 108 24.2 108 54 108 83.8 83.8 108 54 108Z"
            fillRule="nonzero"
            fill="#CFE6FD"
          />
          <path
            d="M101.8 58C101.9 56.7 102 55.3 102 54 102 27.5 80.5 6 54 6 52.7 6 51.3 6.1 50 6.2L50 0.1C51.3 0 52.7 0 54 0 83.8 0 108 24.2 108 54 108 55.3 108 56.7 107.9 58L101.8 58Z"
            fill="#3181F7"
          />
          <animateTransform
            attributeType="xml"
            attributeName="transform"
            type="rotate"
            from="0"
            to="360"
            dur="0.7s"
            repeatCount="indefinite"
          />
        </svg>
      </div>

      <SourcesList />
      <style jsx>{styles}</style>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/Sources/redirectingTo/components/RedirectingToLayout/index.js